import {
	AUTH_LOG_OUT_ACTION_TYPE,
	AUTH_PKCE_LOGIN_REQUEST_ACTION_TYPE,
	AuthLogOutAction,
	AuthPKCELoginRequestAction,
	dispatchAction
} from 'studiokit-scaffolding-js'

export const logIn = () => {
	dispatchAction<AuthPKCELoginRequestAction>({
		type: AUTH_PKCE_LOGIN_REQUEST_ACTION_TYPE.PKCE_LOGIN_REQUEST
	})
}

export const logOut = () => {
	dispatchAction<AuthLogOutAction>({ type: AUTH_LOG_OUT_ACTION_TYPE.LOG_OUT })
}
